import { useCallback } from 'react';
import useTriggerRequest from '@/hooks/useTriggerRequest';
import { deleteCartItem } from '@/actions/ecom/cart';
import LocalStorage from '@/utils/localStorage';
import { EFL_CART_ID } from '@/constants/app';
import { useEcomProductContext } from '@/context/ecomProductContext';

export const useCartActions = (setCartData?: (cartData: any) => void) => {
  const cartId = LocalStorage.get(EFL_CART_ID);
  const { dispatch: ecomProductDispatch } = useEcomProductContext();

  const deleteCartItems = (...args: any) => deleteCartItem.apply(null, args);
  const delteItem = useTriggerRequest({ fetch: deleteCartItems });

  const removeItemfn = useCallback(
    async (productId?: string, prexoId?: string, type?: string, materialId?: string) => {
      try {
        const cart = await delteItem.promisifyTrigger(cartId, productId, prexoId, type);
        ecomProductDispatch.updatePrexo({ materialId, prexo: null });

        if (setCartData) {
          setCartData(cart);
        }

        return cart;
      } catch (error) {
        console.error('Error removing cart item:', error);
        throw error;
      }
    },
    [cartId, delteItem, ecomProductDispatch, setCartData],
  );

  return {
    removeItemfn,
    isLoading: delteItem.isLoading,
  };
};
